<template>
    <div>
        <b-modal v-model="show" no-close-on-backdrop :title="tituloTexto" size="sm">
            <b-form-row v-html="mensagemTexto"></b-form-row>
            <template v-slot:modal-footer>
                <div class="row">
                    <b-btn-group class="mr-2">
                        <b-btn block :variant="classe" @click="close">{{ok}}</b-btn>
                    </b-btn-group>
                </div>
            </template>
        </b-modal>
    </div>
</template>

<script>
    export default {
        props: {
            tipo: String,
            titulo: String,
            mensagem: { default: '' },
            ok: { default: 'OK' },
            show: { default: false }
        },
        methods: {
            close() {
                this.$api.UI.Close()
            }
        },
        computed: {
            classe() {
                switch (this.tipo) {
                    case 'info':
                        return 'info'
                        break
                    case 'alerta':
                        return 'warning'
                        break
                    case 'erro':
                        return 'danger'
                        break
                    default:
                        return 'info'
                        break
                }
            },
            tituloTexto() {
                if (this.titulo) {
                    return this.titulo
                } else {
                    switch (this.tipo) {
                        case 'info':
                            return 'Mensagem'
                            break
                        case 'alerta':
                            return 'Atenção!'
                            break
                        case 'erro':
                            return 'Erro!'
                            break
                        default:
                            return 'Mensagem'
                            break
                    }
                }
            },
            mensagemTexto() {
                if (this.mensagem) {
                    return this.mensagem
                } else {
                    switch (this.tipo) {
                        case 'info':
                            return 'Operacao realizada com sucesso!'
                            break
                        case 'alerta':
                            return 'Operacao não permitida!!'
                            break
                        case 'erro':
                            return 'Houve um erro. Tente novamente, se persistir contate o administrador!'
                            break
                        default:
                            return 'Operacao realizada com sucesso!'
                            break
                    }
                }
            },
            icone() {
                switch (this.tipo) {
                    case 'info':
                        return 'info'
                        break
                    case 'alerta':
                        return 'warning'
                        break
                    case 'erro':
                        return 'error'
                        break
                    default:
                        return 'info'
                        break
                }
            }
        }
    }
</script>
